import { useEffect, useState } from 'react';

const getInitialTheme = () => {
	if (typeof window !== 'undefined') {
		const savedTheme = localStorage.getItem('theme');
		if (savedTheme === 'dark' || savedTheme === 'light') {
			return savedTheme;
		}
		if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
			return 'dark';
		}
	}
	return 'light';
};

const useThemeSwitcher = () => {
	const [theme, setTheme] = useState(getInitialTheme);

	useEffect(() => {
		const root = window.document.documentElement;
		if (theme === 'dark') {
			root.classList.add('dark');
			root.classList.remove('light');
		} else {
			root.classList.remove('dark');
			root.classList.add('light');
		}
		try {
			localStorage.setItem('theme', theme);
		} catch (e) {
			console.warn('Unable to persist theme to localStorage', e);
		}
	}, [theme]);

	const toggleTheme = () => {
		setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
	};

	return [theme, setTheme, toggleTheme];
};

export default useThemeSwitcher;
